export default __webpack_public_path__ + "static/media/sad-icon.37a88a2a.svg";